// Everything about the VEYSO brand that appears in more than one place.
// All figures and copy here are SAMPLE content for the preview build.
export const BRAND = {
  name: "VEYSO",
  tagline: "Stop guessing about your health.",
  showPreviewBar: false, // the footer already says this is a preview build
  cta: { label: "Join VEYSO", short: "Join", to: "/membership" },
};

// Banner pinned above the menu bar on every page. The target page is a placeholder until it is built.
export const PROMO = { text: "Shop exclusive picks", short: "Exclusive picks", cta: "Shop now", to: "/exclusive-picks" };

// Pop-up with three products that opens once per visit as the visitor scrolls below the hero.
export const POPUP = { title: "Exclusive picks for you", sub: "A few products our team likes right now.", afterHeroFactor: 1.5, seeAll: { label: "See all exclusive picks", to: "/exclusive-picks" } };

// Global navigation (on all pages), following the approved site map.
// Items with `children` open a dropdown; the label itself still links to its overview page.
export const NAV = [
  {
    label: "Shop", to: "/shop",
    children: [
      { label: "All products", to: "/shop" },
      { label: "For women", to: "/shop/women" },
      { label: "For men", to: "/shop/men" },
      { label: "Biomarker testing", to: "/testing" },
      { label: "Compare tests", to: "/testing/compare" },
    ],
  },
  { label: "Telehealth", to: "/telehealth" },
  { label: "Memberships", to: "/membership" },
  { label: "Learn", to: "/learn" },
  { label: "Our story", to: "/about" },
];

// Buttons on the right of the menu bar.
export const NAV_ACTIONS = {
  clinicians: { label: "For clinicians", to: "/learn/cme" },
  login: { label: "Member login", to: "/login" },
  account: { label: "My account", to: "/dashboard" },
};

// Footer columns (Figma): SHOP, TESTING, CARE, LEARN, COMPANY.
export const FOOTER_COLS = [
  { title: "Shop", links: [["All products", "/shop"], ["For men", "/shop/men"], ["For women", "/shop/women"], ["Memberships", "/membership"]] },
  { title: "Testing", links: [["All tests", "/testing"], ["How it works", "/how-it-works"]] },
  { title: "Care", links: [["Book a visit", "/get-care"], ["Hormone care", "/get-care/info/hormone-therapy"], ["Peptide care", "/get-care/info/peptides"], ["Our clinicians", "/get-care/info/providers"]] },
  { title: "Learn", links: [["VEYSO YOU", "/learn"], ["Videos", "/learn/videos"]] },
  { title: "Company", links: [["About", "/about"], ["Our standard", "/about"], ["Contact", "/contact"], ["FAQ", "/faqs"]] },
];

export const SOCIAL = ["Instagram", "TikTok", "YouTube", "LinkedIn"];

export const LEGAL_LINKS = [["Privacy", "/privacy"], ["Terms", "/terms"], ["HIPAA notice", "/privacy"], ["Accessibility", "/contact"]];

// Pages the search box can jump to.
export const SEARCH_INDEX = [
  ...NAV.flatMap((n) => [{ label: n.label, to: n.to }, ...(n.children || [])]),
  { label: "Testing", to: "/testing" },
  { label: "Get care", to: "/get-care" },
  { label: "Membership: VEYSO+ and VEYSO Precision", to: "/membership" },
  { label: "For women", to: "/women" },
  { label: "For men", to: "/men" },
  { label: "FAQs", to: "/faqs" },
  { label: "Contact", to: "/contact" },
];
